import { Box, Button, Container, Link } from '@mui/material';
import React from 'react';
import { Route, NavLink as RouterLink } from 'react-router-dom';

import { ProdDataSwitch } from 'app/components/form-controls/prod-data-switch';
import { RequireRole } from 'app/components/require-role';
import { Role } from 'app/constants/role';

export class CrisHeader extends React.Component {
    public render(): React.ReactNode {
        return (
            <Container maxWidth={false} style={{ background: '#f5f5f5' }}>
                <Box display='flex'>
                    <Box display='flex' sx={{ flexWrap: 'wrap', gap: '1.5rem' }} className='my-1'>
                        <Link to='/cris/list' component={RouterLink} underline='hover'>
                            List
                        </Link>
                        <RequireRole roles={Role.CRIS_USER}>
                            <Link to='/cris/kanban' component={RouterLink} underline='hover'>
                                Team Kanban
                            </Link>

                            <Link to='/cris/taxonomy' component={RouterLink} underline='hover'>
                                Taxonomy
                            </Link>
                            <Link to='/cris/brands' component={RouterLink} underline='hover'>
                                Brands
                            </Link>
                            <Link to='/cris/stores' component={RouterLink} underline='hover'>
                                Stores
                            </Link>
                            <Link to='/cris/partners' component={RouterLink} underline='hover'>
                                Partners
                            </Link>
                        </RequireRole>
                        <RequireRole roles={Role.TAXONOMY_ADMIN}>
                            <Link to='/cris/categories' component={RouterLink} underline='hover'>
                                Categories
                            </Link>
                            <Link to='/cris/mccs' component={RouterLink} underline='hover'>
                                MCCs
                            </Link>
                            <Link to='/cris/partner-maps' component={RouterLink} underline='hover'>
                                Partner Map V2
                            </Link>
                            <Link to='/cris/removal-queue' component={RouterLink} underline='hover'>
                                Removal Queue
                            </Link>
                        </RequireRole>
                        <RequireRole roles={Role.SEAM_PROCESS_ADMIN}>
                            <Link to='/cris/clean-patterns' component={RouterLink} underline='hover'>
                                Clean Patterns
                            </Link>
                            <Link to='/cris/thresholds' component={RouterLink} underline='hover'>
                                Thresholds
                            </Link>
                        </RequireRole>
                    </Box>
                    <Box flexGrow={1} />
                    <Box sx={{ flexShrink: 0 }} className='mt-1'>
                        <RequireRole roles={[Role.TAXONOMY_ADMIN, Role.CRIS_USER]}>
                            <Route
                                path={[
                                    '/cris/taxonomy',
                                    '/cris/brands',
                                    '/cris/stores',
                                    '/cris/categories',
                                    // Add other paths as needed
                                ]}
                                render={() => <ProdDataSwitch />}
                            />
                        </RequireRole>
                        <RequireRole roles={[Role.SEAM_PROCESS_ADMIN]}>
                            <Route
                                path={[
                                    '/cris/clean-patterns',
                                    '/cris/thresholds',
                                    // Add other paths as needed
                                ]}
                                render={() => <ProdDataSwitch />}
                            />
                        </RequireRole>
                    </Box>
                    <Box sx={{ flexShrink: 0 }} className='mt-1'>
                        <Button
                            type='button'
                            variant='contained'
                            color='primary'
                            size='small'
                            className='mb-1'
                            component={RouterLink}
                            to='/cris/request/new'
                        >
                            New CRIS Request
                        </Button>
                    </Box>
                </Box>
            </Container>
        );
    }
}
